import store from '../../redux/store';
import { consentData } from './set_consent_data';
 
const checkForNegativePurpose = function () {
    const { vendorList } = store.getState(); 
    return vendorList.list.purposes.length !== consentData.getPurposesAllowed().length;
}

export default checkForNegativePurpose;